/**
 * ALDEX Animations & UX Behaviors
 * Vanilla JS, defer-loaded
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // -----------------------------
  // 1. Scroll reveal (staggered groups)
  // -----------------------------
  function initScrollReveal() {
    var selectors = '.aldex-animate, .aldex-animate-scale, .aldex-animate-left, .aldex-animate-right, .aldex-animate-fade, .aldex-reveal';
    
    // Enable animated states now that JS is running
    document.documentElement.classList.add('js-ready');

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll(selectors).forEach(function (el) { el.classList.add('aldex-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('aldex-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '120px 0px 80px 0px' });

    document.querySelectorAll(selectors).forEach(function (el) {
      // Wrap text content in span for reveal animation
      if (el.classList.contains('aldex-reveal') && !el.querySelector('span')) {
        var text = el.textContent;
        var span = document.createElement('span');
        span.textContent = text;
        el.textContent = '';
        el.appendChild(span);
      }
      
      // If already in or near viewport, make visible immediately
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 150 && rect.bottom > -100) {
        el.classList.add('aldex-visible');
      } else {
        observer.observe(el);
      }
    });

    // Safety timeout: ensure everything is visible after 1200ms
    setTimeout(function () {
      document.querySelectorAll(selectors + ':not(.aldex-visible)').forEach(function (el) {
        el.classList.add('aldex-visible');
      });
    }, 1200);
  }

  // -----------------------------
  // 2. PDP accordions
  // -----------------------------
  function initAccordions() {
    var triggers = document.querySelectorAll('.aldex-accordion-trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var details = trigger.closest('details');
        if (!details) return;
        var content = details.querySelector('.aldex-accordion-content');
        var chevron = details.querySelector('.chevron');
        var isOpen = details.open;

        if (isOpen) {
          if (content) {
            content.style.maxHeight = content.scrollHeight + 'px';
            requestAnimationFrame(function () {
              content.style.maxHeight = '0px';
            });
          }
          setTimeout(function () { details.open = false; }, 250);
          if (chevron) chevron.style.transform = '';
        } else {
          // Close others
          document.querySelectorAll('.aldex-accordion[open]').forEach(function (a) {
            if (a !== details) {
              var c = a.querySelector('.aldex-accordion-content');
              if (c) c.style.maxHeight = '0px';
              setTimeout(function () { a.open = false; }, 250);
              var ch = a.querySelector('.chevron');
              if (ch) ch.style.transform = '';
            }
          });

          details.open = true;
          if (content) {
            content.style.maxHeight = content.scrollHeight + 'px';
            content.addEventListener('transitionend', function once() {
              content.style.maxHeight = 'none';
              content.removeEventListener('transitionend', once);
            });
          }
          if (chevron) chevron.style.transform = 'rotate(180deg)';
        }
      });
    });
  }

  // -----------------------------
  // 3. PDP thumbnail gallery
  // -----------------------------
  // 3. PDP thumbnail gallery (Handled natively by aldex-pdp.liquid)
  // -----------------------------
  function initGallery() {
    // Delegated to aldex-pdp.liquid to avoid conflicting event handlers and timers
  }


  // -----------------------------
  // 4. Variant swatches (PDP)
  // -----------------------------
  function initVariantSwatches() {
    var swatches = document.querySelectorAll('.aldex-swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.closest('.aldex-swatch-group');
        if (!group) return;
        group.querySelectorAll('.aldex-swatch').forEach(function (s) {
          s.classList.remove('selected');
          s.setAttribute('aria-checked', 'false');
        });
        sw.classList.add('selected');
        sw.setAttribute('aria-checked', 'true');
        var input = group.querySelector('input[type="radio"]');
        if (input && sw.dataset.value) {
          input.value = sw.dataset.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // -----------------------------
  // 5. Quantity stepper
  // -----------------------------
  function initQtyStepper() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-action]');
      if (!btn) return;
      var action = btn.dataset.qtyAction;
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var min = parseInt(input.min) || 1;
      var max = parseInt(input.max) || 999;
      var value = parseInt(input.value) || min;
      if (action === 'minus') value = Math.max(min, value - 1);
      if (action === 'plus') value = Math.min(max, value + 1);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // -----------------------------
  // 6. Mobile menu focus trap
  // -----------------------------
  function initFocusTrap() {
    var traps = document.querySelectorAll('[data-focus-trap]');
    traps.forEach(function (container) {
      var previouslyFocused = null;

      function getFocusable() {
        return Array.prototype.slice.call(container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ));
      }

      function onKeydown(e) {
        if (e.key !== 'Tab') return;
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      var observer = new MutationObserver(function () {
        if (container.classList.contains('active') || container.classList.contains('open')) {
          if (!previouslyFocused) {
            previouslyFocused = document.activeElement;
            var focusable = getFocusable();
            if (focusable.length) focusable[0].focus();
            document.addEventListener('keydown', onKeydown);
          }
        } else {
          if (previouslyFocused) {
            previouslyFocused.focus();
            previouslyFocused = null;
            document.removeEventListener('keydown', onKeydown);
          }
        }
      });

      observer.observe(container, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // -----------------------------
  // 7. Toast utility
  // -----------------------------
  window.aldexToast = function (message, duration) {
    duration = duration || 3000;
    var existing = document.querySelector('.aldex-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'aldex-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('visible');
    });
    setTimeout(function () {
      toast.classList.remove('visible');
      setTimeout(function () { toast.remove(); }, 400);
    }, duration);
  };

  // -----------------------------
  // 8. Live region for cart announcements
  // -----------------------------
  function ensureLiveRegion() {
    if (document.getElementById('aldex-live-region')) return;
    var region = document.createElement('div');
    region.id = 'aldex-live-region';
    region.className = 'sr-only';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
  }

  window.aldexAnnounce = function (message) {
    var region = document.getElementById('aldex-live-region');
    if (!region) ensureLiveRegion();
    region = document.getElementById('aldex-live-region');
    region.textContent = '';
    setTimeout(function () { region.textContent = message; }, 100);
  };

  // -----------------------------
  // 9. Header scroll state (frosted glass)
  // -----------------------------
  function initHeaderScroll() {
    var header = document.querySelector('.aldex-header');
    if (!header) return;
    var ticking = false;
    function update() {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // -----------------------------
  // INIT
  // -----------------------------
  ready(function () {
    ensureLiveRegion();
    initScrollReveal();
    initHeaderScroll();
    initAccordions();
    initGallery();
    initVariantSwatches();
    initQtyStepper();
    initFocusTrap();
  });
})();
